window.customElements.define(
    "alert-on-email-change",
    class extends HTMLElement {
        connectedCallback() {
            const form: HTMLFormElement | null = document.querySelector('#my-account-details-form');
            const modal: HTMLDialogElement | null = document.querySelector('dialog');

            form?.addEventListener('submit', (event) => {
                const emailInput: HTMLInputElement | null = form.querySelector('[name="email"][data-old-value]');

                if (
                    emailInput
                    && emailInput.value !== emailInput.getAttribute('data-old-value')
                    && modal?.open === false
                ) {
                    event.preventDefault();
                    modal.showModal();
                }
            });
        }
    },
);
